//
// aos.js
// Safe fix: refresh after layout settles + reveal stuck in-viewport elements.
// Avoids hard-refresh storms / cross-module hooks that can break header UI.
//

import AOS from 'aos';

const aosOptions = {
  duration: 700,
  easing: 'ease-out-quad',
  once: true,
  offset: 40,
};

let aosInstance = null;
let settleTimer = null;
let loadListenerAttached = false;

const revealStuckInViewport = () => {
  const viewportBottom = window.pageYOffset + window.innerHeight + 80;

  document.querySelectorAll('[data-aos]:not(.aos-animate)').forEach((el) => {
    const top = el.getBoundingClientRect().top + window.pageYOffset;
    if (top <= viewportBottom) {
      el.classList.add('aos-animate');
    }
  });
};

const refreshAosSafe = () => {
  if (!aosInstance) {
    return;
  }

  try {
    AOS.refresh();
    revealStuckInViewport();
  } catch (error) {
    // Never let AOS break unrelated UI (e.g. header / hamburger).
    console.warn('[aos] refresh skipped', error);
  }
};

const scheduleSettleRefresh = () => {
  if (settleTimer) {
    window.clearTimeout(settleTimer);
  }

  // Single delayed pass after Shuffle / images / Barba paint.
  settleTimer = window.setTimeout(() => {
    refreshAosSafe();
  }, 400);
};

const ensureLoadRefresh = () => {
  if (document.readyState === 'complete') {
    refreshAosSafe();
    return;
  }

  if (!loadListenerAttached) {
    loadListenerAttached = true;
    window.addEventListener(
      'load',
      () => {
        refreshAosSafe();
      },
      { once: true }
    );
  }
};

export default class AOSAnimation {
  constructor() {
    AOS.init(aosOptions);
    ensureLoadRefresh();
    scheduleSettleRefresh();
  }

  addAnimation(elementSelector, animationType, duration, delay) {
    const element = document.querySelector(elementSelector);
    if (element) {
      element.setAttribute('data-aos', animationType);
      if (duration) element.setAttribute('data-aos-duration', duration);
      if (delay) element.setAttribute('data-aos-delay', delay);
      scheduleSettleRefresh();
    }
  }
}

export const initAos = () => {
  if (aosInstance) {
    try {
      AOS.refreshHard();
    } catch (error) {
      console.warn('[aos] refreshHard skipped', error);
    }
    refreshAosSafe();
    scheduleSettleRefresh();
    return aosInstance;
  }

  aosInstance = new AOSAnimation();
  return aosInstance;
};

initAos();
